import React, { Component } from 'react';
import anime from 'animejs';
import './index.less'
/*var isTime = true;
const hover = {
    "stroke-dashoffset":0
}*/
/*function changeTime(){
    var classVal = document.getElementById('polyline');
    if(isTime){
        classVal.style.strokeDashoffset = '0';
        isTime = !isTime;
    }else{
        classVal.style.strokeDashoffset = '3000';
        isTime = !isTime;
    }
}*/
export default class Loader extends Component{
    constructor(props){
        super(props);
        this.state ={
            isTime:true
        }
    }
    componentDidMount() {
        var classVal = document.getElementById('polyline');
        console.log(classVal.style)
        // setInterval(function () {
        //     changeTime();
        // },3000)
        console.log(classVal)
        anime({
            targets: classVal,
            strokeDashoffset: [anime.setDashoffset, 0],
            easing: 'easeInOutSine',
            duration: 1500,
            delay: function(el, i) { return i * 250 },
            // direction: 'alternate',
            loop: true
        })
    }

    render() {
        const { cTitle, eTitle } = this.props;
        return(
            <div>
                <svg className="loader" enableBackground="new 0 0 200 200" height={200} id="loader" version="1.1"
                     viewBox="0 0 200 200" width="200" xmlns="https://www.w3.org/2000/svg">
                    <text x="57" y="58" dy="50" width="100" height="56" fontSize="50" fontWeight="bold">{cTitle}</text>
                    <text x="81" y="80" dy="60" width="38" height="20" fontSize="18" fontWeight="bold">{eTitle}</text>
                    <polyline id="polyline" fill="none" points="2.5,2.5 197.5,2.5 197.5,197.5 2.5,197.5 2.5,0" stroke="#000000" strokeMiterlimit="10" strokeWidth="5" ></polyline>
                </svg>
            </div>
        )
    }
}
